const routes = [{
  path: '/ThemeCustom',
  name: 'ThemeCustom',
  component: () => import('./pages/ThemeCustom'),
  meta: {
    // dependApp: true,
    requireAuth: true
  }
}];
export default routes